import moment from 'moment'

export function getLocale() {
  return navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language
}

export function getBrowserTz() {
  const offset = moment().format('ZZ')
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  return {
    offset,
    tz,
  }
}

export function getTzAbbr(tz) {
  tz = tz || getBrowserTz().tz

  // Since our vue i18n config doesn't change browser locale info,
  // we hard code it to id for now
  // const locale = getLocale()
  const locale = 'id'

  const tzAbbr = new Date()
    .toLocaleDateString(locale, {
      day: '2-digit',
      // timeZoneName: tz === 'Asia/Jakarta' ? 'shortGeneric' : 'long',
      timeZoneName: 'shortGeneric',
      timeZone: tz,
    })
    .slice(4)

  return tzAbbr
}

export function formatDateWithTz(input, format = 'DD MMM YYYY HH:mm', empty = '-') {
  if (!input) return empty

  // This value will be Asia/Jakarta, etc.
  const tz = getBrowserTz().tz
  const tzAbbr = getTzAbbr(tz)

  return moment(input).format(format) + ' ' + tzAbbr
}

export function formatIndexDate(input, dateFormat = 'DD MMM YYYY') {
  const timeWithTz = formatDateWithTz(input, 'HH:mm')
  const date = moment(input).format(dateFormat)

  return {
    date: date == 'Invalid date' ? '-' : date,
    time: timeWithTz == 'Invalid date' ? '-' : timeWithTz,
  }
}

export function parseISO8601Duration(isoDuration) {
  const regex =
    /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/
  const matches = isoDuration.match(regex)

  if (!matches) {
    return null
  }

  return {
    years: matches[1] ? parseInt(matches[1]) : null,
    months: matches[2] ? parseInt(matches[2]) : null,
    weeks: matches[3] ? parseInt(matches[3]) : null,
    days: matches[4] ? parseInt(matches[4]) : null,
    hours: matches[5] ? parseInt(matches[5]) : null,
    minutes: matches[6] ? parseInt(matches[6]) : null,
    seconds: matches[7] ? parseFloat(matches[7]) : null,
  }
}
